/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RegisterUserWithLinkCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['username', codecString],
    ['password', codecString],
    ['email', codecString],
    ['name', codecString],
]);
export class RegisterUserWithLinkCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RegisterUserWithLinkCourseDataParser.decode(input).map(res => new RegisterUserWithLinkCourseData(res));
    }
    static unsafeDecode(input) {
        return RegisterUserWithLinkCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RegisterUserWithLinkCourseDataParser.encode(data);
    }
    static schema() {
        return RegisterUserWithLinkCourseDataParser.schema();
    }
}
